import React from 'react';
import 'react-dropdown-tree-select/dist/styles.css';
import '../../assets/css/dropdown.css';
import DropdownTreeSelect from 'react-dropdown-tree-select';

class AgentsTree extends React.Component {
  shouldComponentUpdate(nextProps) {
    return (
      JSON.stringify(nextProps) !==
      JSON.stringify(this.props)
    );
  }
  render() {
    return (
      <div className="form-control u-margin-bottom-small">
        <DropdownTreeSelect
          data={this.props.agentNetwork}
          placeholderText="Agente"
          noMatchesText="Sin coincidencias"
          onChange={this.props.onChange}
        />
      </div>
    );
  }
}

export default AgentsTree;



// WEBPACK FOOTER //
// ./src/components/SentBudgets/AgentsTree.js